import React, { Component } from 'react';
import { Input, Modal, Radio, InputNumber } from 'antd';
import { winType1, winType2, sizeWidth2, sizeHeight2, wallInstall, standardsTypes, rodrailsTypes, singlePulley1, singlePulley } from '../../../utils/remark';
const floor = ['单层', '双层', '仅限单层', '建议单层', '建议双层'];//层数
const judge = ['是', '否'];//是否超高
const finial = ['两边装饰头', '左侧平头', '右侧平头', '双侧平头'];//装饰头
class RemarksModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      index: 0,
      type: '',
      data: {
        prop1: '',
        prop2: '',
        prop3: '',
        prop4: '',
        prop5: '',
        prop6: '',
        prop7: '',
        prop8: '',
        prop9: '',
        prop10: '',
        prop11: '',
        prop12: '',
        prop13: '',
        prop14: '',
        prop15: '',
        prop16: '',
        prop17: '',
        prop18: '',
        prop19: '',
        prop20: '',
        prop21: '',
      },
      closeRemark: '',
    }
  }
  render() {
    const { visible, data, closeRemark } = this.state;
    return (
      <Modal
        title='常用备注'
        visible={visible}
        onCancel={this.onCancel}
        onOk={this.onOk}
        width={670}
        okText='确定'
        cancelText='取消'
      >
        <div>
          {/* 层数： */}
          {
            !(standardsTypes.concat(['磁控百叶'])).includes(data.prop1) &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 w70'>层数：</div>
              <Radio.Group value={data.prop5} className='row-w w500'>
                {
                  floor.map((item, indexs) => {
                    return (
                      <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop5')}>{item}</Radio>
                    )
                  })
                }
              </Radio.Group>
            </div>
          }
          {/* 开合方式： */}
          {
            !(standardsTypes.concat(['磁控百叶'])).includes(data.prop1) &&
            <div className='padding-b5 margin-b5 bottomLine'>
              <div className='row-l w100 margin-b5'>
                <div className='margin-r5 w70'>开合方式：</div>
                <Radio.Group value={data.prop6.split('|')[0]} onChange={this.onRemarksChange.bind(this, 'prop60')}>
                  <Radio value={'单开'}>单开</Radio>
                  <Radio value={'双开'}>双开</Radio>
                </Radio.Group>
              </div>
              <div className='row-l w100'>
                <div className='margin-r5 w70 opacity0 none-select'>开合方式：</div>
                {
                  data.prop6.split('|')[0] === '单开' &&
                  <div className='row'>
                    <Radio.Group value={data.prop6.split('|')[1]} onChange={this.onRemarksChange.bind(this, 'prop61')}>
                      <Radio value={'建议单开'}>建议单开</Radio>
                      <Radio value={'布往左边收'}>布往左边收</Radio>
                      <Radio value={'布往右边收'}>布往右边收</Radio>
                    </Radio.Group>
                  </div>
                }
                {
                  data.prop6.split('|')[0] === '双开' &&
                  <div className='row'>
                    <Radio.Group value={data.prop6.split('|')[1]} onChange={this.onRemarksChange.bind(this, 'prop61')}>
                      <Radio value={'建议平分双开'}>建议平分双开</Radio>
                      <Radio value={'平分双开'}>平分双开</Radio>
                      <Radio value={'多开'}>多开</Radio>
                      <Radio value={'大小片'}>大小片</Radio>
                      <Radio value={'备注'}>备注</Radio>
                    </Radio.Group>
                  </div>
                }
              </div>
              <div className='row-l'>
                <div className='w70'></div>
                {
                  ['多开', '大小片', '备注'].includes(data.prop6.split('|')[1]) &&
                  <Input value={data.prop6.split('|')[2]} className='w400' placeholder='特殊备注'
                    onChange={this.onRemarksChange.bind(this, 'prop62')} />
                }

              </div>
              {/* <Radio.Group value={data.prop6} className='row-w w500'>
              {
                closed.map((item, indexs) => {
                  return (
                    <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop6')}>{item}</Radio>
                  )
                })
              }
            </Radio.Group>
            {
              data.prop6 === '特殊备注' &&
              <Input value={closeRemark} className='w220' placeholder='特殊备注' onChange={this.changeClose} />
            } */}

            </div>
          }
          {/* 窗户类型1 内开窗距离：*/}
          {
            data.prop1 !== '磁控百叶' &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='col-t vertical-lt margin-r5 w90'>
                <div className=''>窗户类型1：</div>
                <div className=''>是否内开窗</div>
              </div>
              <Radio.Group value={data.prop7.split('|')[1]} onChange={this.changeWin.bind(this, 1)} className='row-w w200'>
                <Radio value={'是'}>是</Radio>
                <Radio value={'否'}>否</Radio>
              </Radio.Group>
              {
                data.prop7.split('|')[1] === '是' &&
                <div className='row-l'>
                  <div>内开窗到安装距离：</div>
                  <Input value={data.prop7 ? data.prop7.split('|')[2] : ''} onChange={this.changeWin.bind(this, 2)} className='w200' addonAfter='厘米' />
                </div>
              }
            </div>
          }
          {/* 窗户类型2： */}
          <div className='row-l padding-b5 margin-b5 bottomLine'>
            <div className='margin-r5 w90'>窗户类型2：</div>
            <Radio.Group value={data.prop7.split('|')[0]} onChange={this.changeWin.bind(this, 0)} className='row-w w500'>
              {
                winType1.map((item, indexs) => {
                  return (
                    <Radio value={item} key={indexs}>{item}</Radio>
                  )
                })
              }
              {
                winType2.map((item, indexs) => {
                  return (
                    <Radio value={item} key={indexs}>{item}</Radio>
                  )
                })
              }
            </Radio.Group>
          </div>
          {/* 玻璃满墙 */}
          {data.prop17.split('|')[0] === '电动' && !['无类型(幔)已安装', '无类型(熨烫)已安装', '宜家轨道已安装',
            '窗帘盒挡板已安装', '连体轨道已安装',].includes(data.prop1 + data.prop2) &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 mw110'>是否玻璃满墙：</div>
              <Radio.Group value={data.prop17.split('|')[3]} className='row-w w500'>
                {
                  judge.map((item, indexs) => {
                    return (
                      <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop173')}>{item}</Radio>
                    )
                  })
                }
              </Radio.Group>
            </div>
          }

          {/* 墙面材质： */}
          <div className='row-l padding-b5 margin-b5 bottomLine'>
            <div className='margin-r5 w70'>墙面材质：</div>
            <Radio.Group value={data.prop9} className='row-w w500'>
              {
                wallInstall.map((item, indexs) => {
                  return (
                    <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop9')}>{item}</Radio>
                  )
                })
              }
            </Radio.Group>
          </div>
          {/* 是否超高： */}
          <div className='row-l padding-b5 margin-b5 bottomLine'>
            <div className='margin-r5 w70'>是否超高：</div>
            <Radio.Group value={data.prop10} className='row-w w500'>
              {
                judge.map((item, indexs) => {
                  return (
                    <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop10')}>{item}</Radio>
                  )
                })
              }
            </Radio.Group>
          </div>
          {/* 是否拆旧： */}
          <div className='row-l padding-b5 margin-b5 bottomLine'>
            <div className='margin-r5 w70'>是否拆旧：</div>
            <Radio.Group value={data.prop11} className='row-w w500'>
              {
                judge.map((item, indexs) => {
                  return (
                    <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop11')}>{item}</Radio>
                  )
                })
              }
            </Radio.Group>
          </div>

          {/* // 是否裁断发货 */}
          {/* {
            ['罗马杆', '宜家罗马杆'].includes(data.prop1) &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 w70'>是否裁断发货：</div>
              <Radio.Group value={data.prop21} className='row-w w500'>
                {
                  judge.map((item, indexs) => {
                    return (
                      <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop21')}>{item}</Radio>
                    )
                  })
                }
              </Radio.Group>
            </div>
          } */}
          {/* 离地要求：离地（）公分 */}
          {
            ['罗马杆', '宜家罗马杆', '梦幻帘'].concat(rodrailsTypes).includes(data.prop1) &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 w90'>离地/离台尺寸：</div>
              <InputNumber value={data.prop19} className='w110' placeholder='' addonAfter='厘米' addonBefore='离地'
                onChange={this.onRemarksChange.bind(this, 'prop19')} />
            </div>
          }
          {/* // 包边情况： */}
          {
            data.prop16.split('|')[0] === '有' && ['梦幻帘'].concat(rodrailsTypes).includes(data.prop1) &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 w90'>包边情况：</div>
              <Radio.Group value={data.prop16.split('|')[2]} onChange={this.changeLine} className='row-w w500'>
                <Radio value='两侧包边'>两侧包边</Radio>
                <Radio value='左侧包边'>左侧包边</Radio>
                <Radio value='右侧包边'>右侧包边</Radio>
                <Radio value='无包边'>无包边</Radio>
              </Radio.Group>
            </div>
          }
          {/* 是否做飘窗垫： */}
          {
            !['罗马杆', '宜家罗马杆', '磁控百叶'].includes(data.prop1) &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 mw110'>是否做飘窗垫：</div>
              <Radio.Group value={data.prop20.split('|')[0]} onChange={this.changePad.bind(this, 0)} className='row-w w200'>
                <Radio value='是'>是</Radio>
                <Radio value='否'>否</Radio>
              </Radio.Group>
              {
                data.prop20 && data.prop20.split('|')[0] === '是' &&
                <div className='row-l'>
                  <div>飘窗垫厚度：</div>
                  <Input value={data.prop20.split('|')[1]} onChange={this.changePad.bind(this, 1)} className='row-w w200' addonAfter='厘米' />
                </div>
              }
            </div>
          }
          {
            // 有无把手凸出
            standardsTypes.includes(data.prop1) && data.prop2 !== '已安装' &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 mw110'>有无把手凸出：</div>
              <Radio.Group value={data.prop21.split('|')[0]} onChange={this.changeHand.bind(this, 0)} className='row-w w200'>
                <Radio value='有'>有</Radio>
                <Radio value='无'>无</Radio>
              </Radio.Group>
              {
                data.prop21 && data.prop21.split('|')[0] === '有' &&
                <div className='row-l'>
                  <div>凸出尺寸：</div>
                  <Input value={data.prop21.split('|')[1]} onChange={this.changeHand.bind(this, 1)} className='row-w w200' addonAfter='厘米' />
                </div>
              }
            </div>
          }
          {
            // 是否有窗台石凸出
            data.prop1 === '梦幻帘' && data.prop2 !== '已安装' &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 mw110'>有无窗台石：</div>
              <Radio.Group value={data.prop21 ? data.prop21.split('|')[0] : ''} onChange={this.changeHand.bind(this, 0)} className='row-w w200'>
                <Radio value='是'>是</Radio>
                <Radio value='否'>否</Radio>
              </Radio.Group>
              {
                data.prop21 && data.prop21.split('|')[0] === '是' &&
                <div className='row-l'>
                  <div>凸出尺寸：</div>
                  <Input value={data.prop21.split('|')[1] ? data.prop21.split('|')[1] : ''} onChange={this.changeHand.bind(this, 1)}
                    className='row-w w200' addonAfter='厘米' />
                </div>
              }
            </div>
          }
          {
            data.prop1 === '磁控百叶' &&
            <div className='row-w padding-b5 margin-b5 bottomLine'>
              <Input value={data.prop20} addonBefore='c' onChange={this.onRemarksChange.bind(this, 'prop20')} className='w150' addonAfter='厘米' />
              <Input value={data.prop5} addonBefore='d' onChange={this.onRemarksChange.bind(this, 'prop5')} className='w150' addonAfter='厘米' />
              <Input value={data.prop16} addonBefore='e上' onChange={this.onRemarksChange.bind(this, 'prop16')} className='w150' addonAfter='厘米' />
              <Input value={data.prop21} addonBefore='e下' onChange={this.onRemarksChange.bind(this, 'prop21')} className='w150' addonAfter='厘米' />
              <Input value={data.prop13} addonBefore='e左' onChange={this.onRemarksChange.bind(this, 'prop13')} className='w150' addonAfter='厘米' />
              <Input value={data.prop19} addonBefore='e右' onChange={this.onRemarksChange.bind(this, 'prop199')} className='w150' addonAfter='厘米' />
            </div>
          }
          {/* // 活动走珠间隙： */}
          {
            ['蛇形帘'].includes(data.prop1) && data.prop2 === '已安装' &&
            <div className='row-w padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5'>活动走珠间隙：</div>
              <Input value={data.prop13} onChange={this.onRemarksChange.bind(this, 'prop13')} className='w150' addonAfter='厘米' />
            </div>
          }
          {/* {
            // 吊环：
            data.prop1 === '罗马杆' && data.prop2 === '已安装' &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 w70'>吊环：</div>
              <Radio.Group value={data.prop13} className='row-w w500'>
                {
                  rings.map((item, indexs) => {
                    return (
                      <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop13')}>{item}</Radio>
                    )
                  })
                }
              </Radio.Group>
            </div>
          } */}
          {
            // 装饰头：
            ['罗马杆', '宜家罗马杆'].includes(data.prop1) && data.prop2 !== '已安装' &&
            <div className='row-l padding-b5 margin-b5 bottomLine'>
              <div className='margin-r5 w70'>装饰头：</div>
              <Radio.Group value={data.prop13} className='row-w w500'>
                {
                  finial.map((item, indexs) => {
                    return (
                      <Radio value={item} key={indexs} onChange={this.onRemarksChange.bind(this, 'prop13')}>{item}</Radio>
                    )
                  })
                }
              </Radio.Group>
            </div>
          }
          {
            // 滑轮
            (singlePulley.includes(data.prop1) || ['罗马杆', '宜家罗马杆'].includes(data.prop1)) && data.prop2 === '已安装' &&
            <div className='row-w padding-b5 margin-b5 bottomLine'>
              {
                singlePulley.includes(data.prop1) &&
                <div className='row-l'>
                  <div className='margin-r5 mw110'>单层走珠数量：</div>
                  <Input value={data.prop4.split('|')[1]} onChange={this.onRemarksChange.bind(this, 'prop41')} className='w150' addonAfter='个' />
                </div>
              }
              {
                ['罗马杆', '宜家罗马杆'].includes(data.prop1) && ['单层吊环', '双层吊环'].includes(data.prop4.split('|')[2]) &&
                <div className='row-l'>
                  <div className='margin-r5 mw110'>单层吊环数量：</div>
                  <Input value={data.prop4.split('|')[1]} onChange={this.onRemarksChange.bind(this, 'prop41')} className='w150' addonAfter='个' />
                </div>
              }
              {
                singlePulley1.includes(data.prop1) &&
                <div className='row'>
                  <div>是否含{data.prop17.split('|')[0] === '电动' ? '固定环和滑车臂环' : '两头固定环'}：</div>
                  <Radio.Group value={data.prop4.split('|')[2]} onChange={this.onRemarksChange.bind(this, 'prop42')} className='row-w w200'>
                    <Radio value='是'>是</Radio>
                    <Radio value='否'>否</Radio>
                  </Radio.Group>
                </div>
              }
              {
                ['罗马杆', '宜家罗马杆'].includes(data.prop1) &&
                <div className='row'>
                  <div>吊环：</div>
                  <Radio.Group value={data.prop4.split('|')[2]} onChange={this.onRemarksChange.bind(this, 'prop42')} className='row-w w280'>
                    <Radio value='双层吊环'>双层吊环</Radio>
                    <Radio value='单层吊环'>单层吊环</Radio>
                    <Radio value='无吊环'>无吊环</Radio>
                  </Radio.Group>
                </div>
              }
            </div>
          }
        </div>
      </Modal>
    );
  }
  onRemarksChange = (prop, e) => {
    let data = _.cloneDeep(this.state.data);
    if (prop === 'prop19') {
      data[prop] = e === null ? '' : e;
    } else if (prop === 'prop199') {
      data.prop19 = e.target.value;
    } else if (prop === 'prop173') {
      let prop17 = data.prop17.split('|');
      prop17[3] = e.target.value
      data.prop17 = prop17.join('|');
    } else if (prop === 'prop42') {
      let prop4 = data.prop4.split('|');
      prop4[2] = e.target.value
      if (e.target.value === '无吊环') {
        prop4[1] = '/';
      }
      data.prop4 = prop4.join('|');
    } else if (prop === 'prop41') {
      let prop4 = data.prop4.split('|');
      prop4[1] = e.target.value
      data.prop4 = prop4.join('|');
    } else if (prop === 'prop60') {
      let prop6 = data.prop6.split('|');
      prop6[0] = e.target.value
      prop6[1] = e.target.value === '单开' ? '布往右边收' : '平分双开';
      prop6[2] = '';
      data.prop6 = prop6.join('|');
    } else if (prop === 'prop61') {
      let prop6 = data.prop6.split('|');
      prop6[1] = e.target.value
      if (['建议平分双开', '平分双开'].includes(e.target.value)) {
        prop6[2] = '';
      }
      data.prop6 = prop6.join('|');
    } else if (prop === 'prop62') {
      let prop6 = data.prop6.split('|');
      prop6[2] = e.target.value
      data.prop6 = prop6.join('|');
    } else {
      data[prop] = e.target.value;
    }
    this.setState({
      data: data
    })
  }

  //窗户类型|内开窗
  changeWin = (sort, e) => {
    let data = _.cloneDeep(this.state.data);
    let prop7 = data.prop7.split('|');
    prop7[sort] = e.target.value;
    if (sort === 1 && e.target.value === '否') {
      prop7[2] = '';
    } else if (sort === 0) {
      if (sizeWidth2(data.prop1, data.prop2, e.target.value)[0]) {
        data.width_remark = sizeWidth2(data.prop1, data.prop2, e.target.value)[0];
      } else {
        data.width_remark = '自定义';
      }
      if (sizeHeight2(data.prop1, data.prop2, e.target.value)[0]) {
        data.height_remark = sizeHeight2(data.prop1, data.prop2, e.target.value)[0];
      } else {
        data.height_remark = '自定义';
      }
    }
    data.prop7 = prop7.join('|');
    this.setState({
      data: data
    })
  }
  //包边
  changeLine = (e) => {
    let data = _.cloneDeep(this.state.data);
    let prop16 = data.prop16.split('|');
    prop16[2] = e.target.value;
    data.prop16 = prop16.join('|');
    this.setState({
      data: data
    })
  }
  //飘窗垫
  changePad = (sort, e) => {
    let data = _.cloneDeep(this.state.data);
    let prop20 = data.prop20.split('|');
    prop20[sort] = e.target.value;
    data.prop20 = prop20.join('|');
    this.setState({
      data: data
    })
  }
  // 有无把手凸出
  changeHand = (sort, e) => {
    let data = _.cloneDeep(this.state.data);
    let prop21 = data.prop21.split('|');
    prop21[sort] = e.target.value;
    data.prop21 = prop21.join('|');
    this.setState({
      data: data
    })
  }
  //开合方式-特殊备注
  changeClose = (e) => {
    this.setState({
      closeRemark: e.target.value,
    });
  }
  onShowModal = (index, data) => {
    let newData = _.cloneDeep(data);
    // let closeRemark = '';
    // if (!closed.includes(data.prop6)) {
    //   closeRemark = data.prop6;
    //   newData.prop6 = '特殊备注';
    // }
    this.setState({
      visible: true,
      index: index,
      data: newData,
      // closeRemark,
    })
  }
  onOk = () => {
    const { index, data, windowType1, windowType2, closeRemark } = this.state;
    let newdata = _.cloneDeep(data);
    // newdata.prop7 = windowType1 + '|' + windowType2;

    // newdata.prop6 = newdata.prop6 === '特殊备注' ? closeRemark : newdata.prop6;
    newdata.prop19 = newdata.prop19.toString();
    // newdata.prop19 = newdata.prop19 || newdata.prop19 === 0 ? newdata.prop19 : '无';
    this.props.updateTable(newdata, index);
    this.onCancel()
  }
  onCancel = () => {
    this.setState({
      visible: false,
      closeRemark: '',
    })
  }
}

export default RemarksModal;